import { translation as t } from "../../../../inc/helpers";
import Input from "./Input";

export default class InputCheckbox extends Input {
    constructor({ container, label, error }) {
        super({
            container,
            label,
            error,
        });

        this._inputs = Array.from(this._container.querySelectorAll(".input-checkbox"));
        this._value = this._inputs.filter(input => input.getAttribute("aria-checked") === "true");
        this._values = this._inputs.map((input) => input.dataset.value);

        this._min = this._container.hasAttribute("data-min")
            ? parseInt(this._container.getAttribute("data-min"))
            : null;
        this._max = this._container.hasAttribute("data-max")
            ? parseInt(this._container.getAttribute("data-max"))
            : null;

        this._inputCurrOnChecked = [];
    }

    init() {
        this.saveInitialSetup();
        this.initEvs();

        if (this._value.length > 0) {
            this._valid = this._validate(this._value);
            this.handleChange();
            this.toggleValidation();
        }            
    }

    initEvs() {
        this._evOnChange = (e) => this.onChange(e);
        this._evOnBlur = (e) => this.onBlur(e);

        this._inputs.forEach((input) => {
            input.addEventListener("click", this._evOnChange);
            input.addEventListener("blur", this._evOnBlur);
        });
        this._container.addEventListener("keydown", this._evOnChange);
    }

    onChange(e) {
        if (this._readonly || this._disabled) return;

        if (e.type === "keydown") {
            if (e.key === " ") e.preventDefault();
            else return;
        }

        let value = e.target.dataset?.value;
        if (value === undefined)
            value = e.target.closest(".input-checkbox").dataset.value;

        if (!this._values.includes(value))
            return;

        this._value =
            this._value.includes(value)
                ? this._value.filter(v => v !== value)
                : [...this.value, value];

        this._valid = this._validate(this._value);
        this.handleChange();
        this.toggleValidation();

        if (this._inputCurrOnChecked.length > 0)
            this._cbackControls?.(this._inputCurrOnChecked, this);

        if (this._onchange?.length > 0)
            this._cbackControls?.(this._onchange, this);

        if (this._valid.flag === null) return;

        if (this._valid.flag && (this._onvalid?.length > 0)) {
            this._cbackControls?.(this._onvalid, this);

        } else if (!this._valid.flag && (this._oninvalid.length > 0)) {
            this._cbackControls?.(this._oninvalid, this);
        }                

        this.handleDispatch();
    }

    onBlur(e) {
        if (this._readonly || this._disabled)
            return;

        const prev = this._inputs.includes(e.relatedTarget);
        if (prev) return;

        this._valid = this._validate(this._value);
        this.toggleValidation();

        if (this._valid.flag === null) return;

        if (this._valid.flag && (this._onvalid?.length > 0)) {
            this._cbackControls?.(this._onvalid, this);

        } else if (!this._valid.flag && (this._oninvalid.length > 0)) {
            this._cbackControls?.(this._oninvalid, this);
        }

        this.handleDispatch();
    }

    _validate(value) {
        if (!this._required && !(value.length > 0))
            return { flag: null, msg: "" };

        if (this._required && !(value.length > 0))
            return { flag: false, msg: t("ERROR.FieldMandatory") };

        if (!this._min && !this._max)
            return { flag: true, msg: "" };

        if (this._min && (value.length < this._min))
            return {
                flag: false,
                msg: t("ERROR.Min", [this._min]),
            };

        if (this._max && (value.length > this._max))
            return {
                flag: false,
                msg: t("ERROR.Max", [this._max]),
            };

        return { flag: true, msg: "" };
    }

    handleChange() {
        this._inputs.forEach((input) => {
            if (this._value.includes(input.dataset.value)) {
                input.setAttribute("aria-checked", "true");
                return;
            }

            input.setAttribute("aria-checked", "false");
        });
    }

    reset() {
        super.reset();
        this.handleChange();
    }

    get value() {
        return this._value;
    }

    set value(values) {
        if (!Array.isArray(values)) return;

        this.reset();

        values.forEach((value) => {
            if (!this._values.includes(value))
                return;

            if (this._value.includes(value))
                return;

            this._value.push(value);
        });        

        this._valid = this._validate(this._value);

        this.handleChange();
        this.toggleValidation();
    }

    get values() {
        return this._values;
    }

    set values(arr) {
        if (!Array.isArray(arr))
            return;
        this._values = [...arr];
    }
}